export const REQUEST_ICONS = [
    'icon-activities',
    'icon-alert',
    'icon-alert-circle',
    'icon-alert-octagon',
    'icon-alert-octagon-filled',
    'icon-ambulance-5',
    'icon-analytics-graph-bar',
    'icon-arrow-down',
    'icon-arrow-left',
    'icon-arrow-right',
    'icon-arrow-up',
    'icon-assembly',
    'icon-audio-file-volume',
    'icon-baby-trolley',
    'icon-baggage',
    'icon-bciti',
    'icon-beach-6',
    'icon-beach-parasol-water-1',
    'icon-biblio',
    'icon-biking-person',
    'icon-binocular',
    'icon-bomb-grenade',
    'icon-building-2',
    'icon-building-modern-1',
    'icon-calendar',
    'icon-calendar-add',
    'icon-camera',
    'icon-camera-flash',
    'icon-camping-tent-3',
    'icon-car',
    'icon-caret-down',
    'icon-caret-left',
    'icon-caret-right',
    'icon-caret-up',
    'icon-chatbot',
    'icon-chatbot-active',
    'icon-check',
    'icon-check-circle',
    'icon-circle-minus',
    'icon-circle-plus',
    'icon-city',
    'icon-close',
    'icon-close-circle',
    'icon-clock',
    'icon-cog',
    'icon-coffee-cold',
    'icon-coffee-machine',
    'icon-compass',
    'icon-compost-bin',
    'icon-construction',
    'icon-consultation',
    'icon-content-ink-pen-write',
    'icon-content-pen-3',
    'icon-content-typing-machine',
    'icon-couple-man-woman',
    'icon-coupon-cut',
    'icon-crypto-currency-bitcoin-imac',
    'icon-dating-rose',
    'icon-dating-smartphone-man',
    'icon-design-tool-pen-station',
    'icon-design-tool-quill-2',
    'icon-desktop-monitor-download',
    'icon-desktop-monitor-upload',
    'icon-diet-waist-1',
    'icon-discover',
    'icon-drag-handle',
    'icon-e-learning-monitor',
    'icon-edit',
    'icon-email',
    'icon-email-action-receive',
    'icon-envelope',
    'icon-expand',
    'icon-family',
    'icon-faq',
    'icon-favorite',
    'icon-files',
    'icon-filter-picture',
    'icon-fire-extinguisher-sign-4',
    'icon-flag',
    'icon-flip',
    'icon-folder',
    'icon-folder-network',
    'icon-footwear-heels-ankle',
    'icon-gauge-dashboard-1',
    'icon-golf-hole',
    'icon-graffiti',
    'icon-graph-stats-circle',
    'icon-grid',
    'icon-hammer-1',
    'icon-headphones-human',
    'icon-home',
    'icon-home-filled',
    'icon-human-resources-search-employees',
    'icon-ice-rink',
    'icon-image',
    'icon-img-add',
    'icon-info',
    'icon-input-forms',
    'icon-insurance-card',
    'icon-key-lock',
    'icon-lab-flask-experiment',
    'icon-landmark-japan-shrine',
    'icon-laptop-smiley-1',
    'icon-lighter',
    'icon-like-1',
    'icon-link',
    'icon-link-filled',
    'icon-list',
    'icon-login-2',
    'icon-logout',
    'icon-love-boat',
    'icon-map',
    'icon-map-active',
    'icon-maps-pin',
    'icon-medical-personnel-doctor',
    'icon-megaphone-1',
    'icon-menu',
    'icon-messages-people-person-bubble-oval',
    'icon-minus',
    'icon-mobile-phone-2',
    'icon-modern-tv-3d-glasses',
    'icon-money-wallet-open',
    'icon-monkey',
    'icon-mood-happy',
    'icon-more-horizontal',
    'icon-more-vertical',
    'icon-mouse',
    'icon-my-card',
    'icon-nautic-sports-sailing-person',
    'icon-no-parking',
    'icon-notifications',
    'icon-office-file-pdf',
    'icon-office-work-wireless',
    'icon-optimization-timer-1',
    'icon-outdoors-tree-valley',
    'icon-parking',
    'icon-parking-meter',
    'icon-parking-zone',
    'icon-pencil-2',
    'icon-people-man-graduate',
    'icon-people-woman-glasses-1',
    'icon-phone-actions-ring',
    'icon-phone-alerts',
    'icon-phone-upload',
    'icon-photo',
    'icon-photo-collection',
    'icon-pin',
    'icon-pin-monitor',
    'icon-plane-trip-international',
    'icon-plus',
    'icon-pool',
    'icon-pot-hole',
    'icon-presentation-board-graph',
    'icon-print-text',
    'icon-privacy',
    'icon-programming-flag',
    'icon-qr-code',
    'icon-question',
    'icon-rat',
    'icon-receipt',
    'icon-recycling',
    'icon-recycling-bin',
    'icon-refresh',
    'icon-requests',
    'icon-restaurant',
    'icon-rooster',
    'icon-sail-ship-7',
    'icon-schedule-meeting',
    'icon-school-bus-side-1',
    'icon-science-dna',
    'icon-screen-1',
    'icon-sd-card-upload',
    'icon-search',
    'icon-send-email-2',
    'icon-services-status',
    'icon-setting',
    'icon-shield-2-2',
    'icon-shipment-upload',
    'icon-shop',
    'icon-shop-cashier-man',
    'icon-shop-cashier-woman',
    'icon-shopping-bag-heart',
    'icon-shopping-bag-tag-1',
    'icon-shopping-cart-download',
    'icon-show-hat-magician-1',
    'icon-skiing-cross-country',
    'icon-skull',
    'icon-skunk',
    'icon-slippery-ice',
    'icon-snow',
    'icon-snowblower',
    'icon-stamps-famous',
    'icon-star',
    'icon-star-filled',
    'icon-street-lamp',
    'icon-swimming',
    'icon-tablet-touch',
    'icon-tag',
    'icon-tag1',
    'icon-taking-pictures-circle',
    'icon-target-center-2',
    'icon-tennis',
    'icon-text-subject',
    'icon-theatre',
    'icon-timer',
    'icon-town-hall',
    'icon-trash-bin',
    'icon-trash-bin-2',
    'icon-tree',
    'icon-trusted',
    'icon-user-add',
    'icon-user-profile',
    'icon-user-profile-filled',
    'icon-video-game-gamasutra',
    'icon-video-game-mario-3',
    'icon-video-game-mario-enemy',
    'icon-video-player-1',
    'icon-video-player-cloud',
    'icon-video-player-monitor',
    'icon-view',
    'icon-view-headline',
    'icon-view-off',
    'icon-warehouse-cart-packages',
    'icon-warehouse-storage-3',
    'icon-warning',
    'icon-water-in-service',
    'icon-water-service-interruption',
    'icon-wench-double',
    'icon-whale-body',
    'icon-wireless-payment-credit-card-dollar',
];
